module.exports = __webpack_public_path__ + "static/media/logo-blanco.52ea1958.png";